<script>
import { required } from "vuelidate/lib/validators";
import { equalTo } from "../../../helpers/validator_extend_function";

export default {
  components: {},
  props: {},
  data() {
    return {
      invalidCheck: "",
    };
  },
  validations: {
    invalidCheck: { required, equalTo: equalTo(true) },

    form: ["invalidCheck"],
  },
  methods: {
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">تعليمات وشروط التقديم</h5></div>

      <div class="col-md-12">
        <ol>
          <li>
            <p>
              يرجى ملء هذه الاستمارة قبل النشاط بشهر لغرض تجهيز المتطلبات
              كما ينبغي وبالوقت المناسب .
            </p>
          </li>
          <li>
            <p>يرجى ايضاً كتابة تفاصيل البرنامج بالكامل .</p>
          </li>
          <li>
            <p>
              بعد ملء الإستمارة يرجى تأكيد العملية عن طريق إرسال رسالة الى بوت التلكرام
              الموجود في الإسفل .
            </p>
          </li>
          <li>
            <p>
              يرجى العناية بالاجابة فكلما كانت التفاصيل واضحة كلما زادت فرصة نجاح برنامجكم
              وزادت سرعة تقديم الخدمة لكم على اكمل وجه .
            </p>
          </li>
          <li>
            <p>الجواب الذي لا تريد الاجابة عليه اكتب فيه ( مهمل او لا يوجد) .</p>
          </li>
          <!-- <li>
            <p>
              بوت التلجرام
              <a href="http://" target="_blank" rel="noopener noreferrer">اضغط هنا</a> .
            </p>
          </li>
          <li>
            <p>رقم الهاتف 07806012410 .</p>
          </li> -->
        </ol>

        <div class="form-check check-promise mb-3">
          <label class="form-check-label" for="invalidCheck">
            اتعهد بصحة كافة البيانات التي سيتم ادخالها وبخلافه تهمل الاستمارة .
          </label>
          <input
            class="form-check-input"
            type="checkbox"
            value=""
            id="invalidCheck"
            v-model="invalidCheck"
            :class="{ 'is-invalid': $v.invalidCheck.$error }"
          />
          <div v-if="$v.invalidCheck.$error" class="invalid-feedback">
            <span v-if="!$v.invalidCheck.required || !$v.invalidCheck.equalTo"
              >للتقديم على الاستمارة يجب الموافقة على التعهد</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
